import { AgendaVentasComponent } from './../../agenda-ventas/agenda-ventas.component';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  CustomerExtraInfo,
  TicketPriority,
  TicketService,
  TicketView
} from '../../ticket.service';
import { User, UserRequestView, UsersService } from '../../../+admin/+users/users.service';
import { Customer, CustomerRequest, CustomerService } from '../../../+clientes/clientes.service';
import {
  TicketTypeRequestView, TipoTicket,
  TipoTicketService
} from '../../../+admin/+configuraciones/+tickets/+tipos-ticket/tipos.service';
import {
  Categoria,
  CategoryService, SubCategoria
} from '../../../+admin/+configuraciones/+tickets/+categorias/categorias.service';
import { Groups, GroupsService, GroupsByUser } from '../../../+admin/+groups/group.service';
import { PageImpl } from '../../../common/http/PageImpl';
import { Subject, Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { NotificationService } from '../../../shared/utils/notification.service';;
import { NzNotificationService, NzTableComponent } from 'ng-zorro-antd';
import { NgForm } from '@angular/forms';
import { I18nPipe } from '../../../shared/i18n';
import { Router } from '@angular/router';
import { FoliosService, SaleRequest } from '../../../folios/folios.service';
import { VentasService, SalesFoundCustomer, Ticket, CustomerTicket, DevicesAndServicesResponse } from './ventas.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { config } from '../../../shared/smartadmin.config'
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedService } from 'app/shared/shared.service';


type StreetOptions = 'street' | 'street1' | 'street2';
@Component({
  selector: 'app-modal-ventas',
  templateUrl: './modal-ventas.component.html',
  styleUrls: ['./modal-ventas.component.css']
})


export class ModalVentasComponent implements OnInit {
  @Input() mapa: any;
  isSpinning: boolean = false;
  resultados: boolean = false;
  ticket: TicketView = new TicketView();
  nombreCompleto: string = null;
  sucursal: any = null;
  id_calle: any = null;
  street: any;
  numeroCasa: any = null;
  bis: any = null;
  interior: any = null;
  departamento: any = null;
  manzana: any = null;
  lote: any = null;
  numSuscriptor: any = null;
  private currentVenta: SaleRequest = new SaleRequest();
  streetList = [];
  street1List = [];
  street2List = [];
  results: SalesFoundCustomer[] = [];
  mapActives: boolean[] = [];
  mostrarMapa: boolean = false;
  indexActual: number = 0;
  loaderShow: boolean = false;
  private streetRequest: CustomerRequest = new CustomerRequest();
  private infoUserLogger = JSON.parse(localStorage.getItem('info_user_logged'));

  serviceList:any;
  public groupsListSearchSelects: Array<Groups> = [];
  public groupsListSearch: Array<Groups> = [];
  public groups: Array<number> = [];
  public groupsList: any = [];
  selectedGroupInputBusqueda: any;
  mostrarFiltros = false;
  valueInputStreet: string = '';

  colonyList: any[] = [];        // Lista de colonias para el autocomplete
  id_colonia: any = null;        // ID de la colonia seleccionada
  textColony: string = '';       // Texto escrito en el campo de colonia
  
  textStreet: string = '';
  @ViewChild('streetSelect') streetSelect: NgSelectComponent;
  @ViewChild('colonySelect') colonySelect: NgSelectComponent;

  public googleStaticMapAPI = 'http://maps.googleapis.com/maps/api/staticmap?&maptype=roadmap&zoom=16&size=300x450&sensor=false&key=' + config.GOOGLE_API_KEY;
  constructor(public bsModalRef: BsModalRef,
    private notificationService: NzNotificationService,
    private ventasService: VentasService,
    private loading: NzSpinModule,
    private router: Router,
    private bsModalAgent: BsModalRef,
    private bsModalService: BsModalService,
    private groupsService: GroupsService,
    private sharedService: SharedService,) {
    this.sucursal = this.infoUserLogger.userAppView.extra1;
    console.log(this.infoUserLogger)

  }

  ngOnInit() {
    console.log(this.infoUserLogger)
    this.results = [];
    if(this.sucursal <= 0 ){
      this.sucursal=null;
    }
  }


  /**
   * Almacena el texto escrito en el campo de colonia
   */
  setTextColony(value: string): void {
    this.textColony = value;
  }

  /**
   * Busca colonias según el texto ingresado y la sucursal actual
   */
  filterColony(event: string): void {
    if (event && event.length >= 1 && this.sucursal) {
      this.loaderShow = true;
      this.ventasService.suburbFromMega(event, this.sucursal)
        .subscribe((response) => {
          if (response && response.colonias && response.colonias.length) {
            this.colonyList = response.colonias.map(c => ({ ...c, nombre: c.nombre.trim() }));
            setTimeout(() => this.colonySelect.open(), 50);
          } else {
            this.colonyList = [];
          }
          this.loaderShow = false;
        }, (error) => {
          this.loaderShow = false;
          this.colonyList = [];
          this.createNotification('warning', 'Error', 'No se pudieron cargar las colonias');
          console.error('Error al buscar colonias', error);
        });
    } else {
      this.colonyList = [];
    }
  }

  /**
   * Al seleccionar una colonia, limpia la calle seleccionada y su lista
   */
  onColonySelected(selectedColony: any): void {
    console.log('Colonia seleccionada:', selectedColony);
    // Limpiar calle
    this.id_calle = null;
    this.streetList = [];
  }

  filterStreet(event, streetOpt: StreetOptions): void {

    // Validar que exista colonia seleccionada
    if (!this.id_colonia) {
      this.createNotification('warning', 'Falta información', 'Debe ingresar colonia');
      return;
    }

    switch (streetOpt) {
      case 'street':
        this.currentVenta.id_calle = null;
        break;
      case 'street1':
        this.currentVenta.id_entreCalle1 = null;
        break;
      case 'street2':
        this.currentVenta.id_entreCalle2 = null;
    }
    if (event && event.length >= 4) {
      switch (streetOpt) {
        case 'street':
          this.streetList = [];
          break;
        case 'street1':
          this.street1List = [];

          break;
        case 'street2':
          this.street2List = [];
      }
      if(this.sucursal != null && this.sucursal != "" && this.sucursal != undefined){
      this.loaderShow = true;
      this.isSpinning = true;
      
        this.ventasService.streetFromMega(event, this.sucursal, this.id_colonia)
        .subscribe((streetResponse) => {
          this.textStreet = '';
          setTimeout(() => this.streetSelect.open(), 50);
          if (streetResponse.calles && streetResponse.calles.length) {
            this.loaderShow = false;
            this.isSpinning = false;
            switch (streetOpt) {
              case 'street':
                this.streetList = streetResponse.calles;
                break;
              case 'street1':
                this.street1List = streetResponse.calles;
                break;
              case 'street2':
                this.street2List = streetResponse.calles;
            }
          } else {
            this.loaderShow = false;
            this.isSpinning = false;
            // alert('No se encontrarón resultados para: ' + event)
            this.createNotification('info', 'Sin resultados', 'No se encontrarón resultados para: ' + event);
          }
        }, (error) => {
          this.textStreet = '';
          this.loaderShow = false;
          this.isSpinning = false;
          this.createNotification('warning', 'Sin resultado', 'Error en la búsqueda de calles, intente mas tarde.' +
            (error.code == 'custom' ? ' ' + error.message : ''));
          console.error('error al buscar calles', error);
        });
      }else{
        this.createNotification('warning', 'Falta información', 'Debe ingresar la sucursal.');
     
      }
      
    } else {
      this.createNotification('warning', 'Falta información', 'Debe ingresar al menos 4 caracteres para la búsqueda de calles');
    }
  }


  private createNotification(type: string, title?: string, content?: string): void {
    this.notificationService.config({ nzPlacement: 'bottomRight' });
    this.notificationService.create(
      type,
      title,
      content,
      {
        nzAnimate: true
      }
    );
  }

  buscar() {
    console.log(this.sucursal)
    console.log(this.id_calle)
    console.log(this.numeroCasa)
    console.log(this.numSuscriptor)
    console.log(this.bis)
    console.log(this.interior)
    console.log(this.departamento)
    console.log(this.manzana)
    console.log(this.lote)
    var mostrarInfoAdicional = document.getElementById("mostrarInfoAdicional");
    if(mostrarInfoAdicional.style.display == "block" ){
      mostrarInfoAdicional.style.display = "none";
    }
    if(this.mostrarFiltros === true){
      this.mostrarFiltros = !this.mostrarFiltros; 
    }
    if ((this.sucursal && this.id_calle && this.numeroCasa) || (this.sucursal && this.numSuscriptor)) {
      this.loaderShow = true;
      this.isSpinning = true;
      
      this.results = [];
      this.mapActives = [];

      let suscriptor: number;
      let sucursal: number;
      if (this.numSuscriptor && this.numSuscriptor.length === 10) {
        sucursal = Number.parseInt(this.numSuscriptor.slice(0, 3), 10);
        suscriptor = Number.parseInt(this.numSuscriptor.slice(3), 10);
      }else if (this.numSuscriptor && this.numSuscriptor.length === 9) {
        sucursal = Number.parseInt(this.numSuscriptor.slice(0, 2), 10);
        suscriptor = Number.parseInt(this.numSuscriptor.slice(2), 10);
      }else if (this.numSuscriptor && this.numSuscriptor.length === 8) {
        sucursal = Number.parseInt(this.numSuscriptor.slice(0, 1), 10);
        suscriptor = Number.parseInt(this.numSuscriptor.slice(1), 10);
      } 
      else {
        sucursal = null;
        suscriptor = Number.parseInt(this.numSuscriptor, 10);
      }

      let obj = {
        sucursal: this.sucursal ? Number(this.sucursal) : Number(this.infoUserLogger.userAppView.extra1),
        calle: this.id_calle ? this.id_calle : null,
        numero: this.numeroCasa ? Number(this.numeroCasa) : null,
        suscriptor: suscriptor ? Number(suscriptor) : null,
        bis: this.bis ? this.bis : null,
        interior: this.interior ? this.interior : null,
        departamento: this.departamento ? this.departamento : null,
        manzana: this.manzana ? this.manzana : null,
        lote: this.lote ? this.lote : null
      }

      obj = this.clean(obj)
      console.log(obj)
      let infoUserLogged: any = JSON.parse(localStorage.getItem('info_user_logged'));
      let newRequest: any = {
        ...obj,
        userName: infoUserLogged ? infoUserLogged.userAppView.username : "",
        idUserApp: infoUserLogged ? infoUserLogged.userAppView.idUserApp : "",
      } 
      this.ventasService.Get_domicilios(newRequest).subscribe((results: any) => {
        this.resultados = true;
        console.log(results)
        this.results = results
        //     if(this.numSuscriptor != null){
        this.results = [
          {
            sucursal: this.sucursal,
            suscriptor: null,
            calle: this.id_calle,
            numero: this.numeroCasa
          },
          ...results.personas
        ];
        for (let i = 0; i < this.results.length; i++) {
          this.mapActives[i] = false;
        }
        // }
        console.log(this.results)
        this.loaderShow = false;
        this.isSpinning = false;

      }, err => {
        console.log(err)
        this.loaderShow = false;
        this.isSpinning = false;
      })
    } else {
      if(this.numSuscriptor){
        this.createNotification('warning', 'Falta información', 'Ingresa la sucursal');  
      }else{
        this.createNotification('warning', 'Falta información', 'Completa los campos de busqueda');
      }
      
    }
  }

  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  set_calle(calle: string) {
    console.log(calle)
    console.log(this.id_calle)
  }

  vender(customerFound: any) {

      if ((this.nombreCompleto && !customerFound.suscriptor) || (customerFound.suscriptor)) {
      const ticketToCreate: Ticket = new Ticket();
      ticketToCreate.createdDate = new Date();
      ticketToCreate.plannedStartDate = ticketToCreate.createdDate;
      ticketToCreate.plannedEndDate = new Date(ticketToCreate.plannedStartDate.getTime() + (15 * 60 * 1000));
      ticketToCreate.ticketCategory = {
        active: true,
        categoryName: "Ventas",
        code: null,
        color: "#d8c0dc",
        idOrg: "42d18ea4-7386-11ea-bc55-0242ac130003",
        idTypeTicket: 5,
        nameTypeTicket: "Ventas",
        ticketCategoryId: 42
      };

      ticketToCreate.idSubcategory = 954;
      ticketToCreate.channel = 'web';
      if (this.id_calle != null) {
        ticketToCreate.summary = customerFound.calle +
          (customerFound.numero ? ' ' + customerFound.numero : '') +
          (customerFound.bis ? ' ' + customerFound.bis : '') +
          (customerFound.interior ? ' ' + customerFound.interior : '');
        ticketToCreate.description = customerFound.colonia;
        if (customerFound.cp) {
          ticketToCreate.description = (ticketToCreate.description ? ticketToCreate.description + ', ' : '') + customerFound.cp;
        }
        ticketToCreate.description = ticketToCreate.description || 'Sin datos';
      } else {
        ticketToCreate.summary = 'Sin información de domicilio';
        ticketToCreate.description = 'Sin datos';
      }
      ticketToCreate.ticketType = {
        idOrg: "42d18ea4-7386-11ea-bc55-0242ac130003",
        idTicketType: 5,
        prefix: "V",
        proccesInstanceName: undefined,
        taskInstanceName: "helpDeskProcess",
        ticketType: "Ventas"
      };
      ticketToCreate.idUserApp = this.infoUserLogger.userAppView.idUserApp;
      ticketToCreate.assignee = this.infoUserLogger.userAppView.username;
      if (
        this.infoUserLogger.userAppView.groups
        && this.infoUserLogger.userAppView.groups.length
      ) {
        ticketToCreate.idGroup = this.infoUserLogger.userAppView.groups[0].groupId;
        ticketToCreate.group = this.infoUserLogger.userAppView.groups[0].groupName;
      }
      ticketToCreate.idPriority = 4;
      ticketToCreate.priority = 'Pri 4';
      ticketToCreate.customerData = new CustomerTicket();
      if (customerFound.sucursal && customerFound.suscriptor) {
        ticketToCreate.customerData.idExternalCustomer = Number.parseInt(
          customerFound.sucursal.toString() + customerFound.suscriptor.toString(),
          10
        );
        ticketToCreate.extra3 = customerFound.sucursal.toString().padStart(3, '0')
          + customerFound.suscriptor.toString().padStart(7, '0');
      } else {
        ticketToCreate.customerData.idExternalCustomer = this.randomIdExternalCustomer();
      }
      if (this.nombreCompleto) {
        ticketToCreate.customerData.nameComplete = this.nombreCompleto;
      } else {
        ticketToCreate.customerData.nameComplete =
          (customerFound.nombre ? customerFound.nombre : '') +
          (customerFound.ap_pat ? ' ' + customerFound.ap_pat : '') +
          (customerFound.ap_mat ? ' ' + customerFound.ap_mat : '');
      }
      ticketToCreate.customerData.customerInfo = [
        {
          idTicketCustomer: null,
          key: 'nombre',
          legend: 'Nombre',
          value: customerFound.nombre
        },
        {
          idTicketCustomer: null,
          key: 'apellido_paterno',
          legend: 'Apellido Paterno',
          value: customerFound.ap_pat
        },
        {
          idTicketCustomer: null,
          key: 'apellido_materno',
          legend: 'Apellido Materno',
          value: customerFound.ap_mat
        },
        {
          idTicketCustomer: null,
          key: 'nombre_comercial',
          legend: 'Nombre Comercial',
          value: customerFound.nombre_comercial
        },
        {
          idTicketCustomer: null,
          key: 'domicilio',
          legend: 'Domicilio',
          value: this.getSelectedAddress(customerFound)
        },
        {
          idTicketCustomer: null,
          key: 'sucursal',
          legend: 'Sucursal',
          value: typeof customerFound.sucursal === 'number' ?
            customerFound.sucursal.toString() :
            customerFound.sucursal
        },
        {
          idTicketCustomer: null,
          key: 'suscriptor',
          legend: 'Suscriptor',
          value: typeof customerFound.suscriptor === 'number' ?
          customerFound.suscriptor.toString() :
          customerFound.suscriptor
      },
        {
          idTicketCustomer: null,
          key: 'telefono_celular',
          legend: 'Teléfono celular',
          value: customerFound.tel_cel
        },
        {
          idTicketCustomer: null,
          key: 'telefono_casa',
          legend: 'Teléfono casa',
          value: customerFound.tel_casa
        },
        {
          idTicketCustomer: null,
          key: 'telefono_oficina',
          legend: 'Teléfono oficina',
          value: customerFound.tel_ofi
        },
        {
          idTicketCustomer: null,
          key: 'saldo',
          legend: 'Saldo',
          value: customerFound.saldo
        },
        {
          idTicketCustomer: null,
          key: 'email',
          legend: 'Email',
          value: customerFound.email
        }
      ];

      if(customerFound.suscriptor){
        this.ventasService.customerDevicesAndServices(customerFound.suscriptor).subscribe((devicesAndServicesResponse)=> {
          this.serviceList = devicesAndServicesResponse;  // Recepción de servicios de Cliente
  
          ticketToCreate.extraInfoList.push({
            key: 'service_list',
            legend: 'Service list',
            value: JSON.stringify(this.serviceList.services)
          });
        });
      }
      
        ticketToCreate.extraInfoList.push({
          key: 'sucursal',
          legend: 'Sucursal',
          value: this.sucursal
        });

         // 
         if(customerFound.promocion != undefined || customerFound.promocion != null){
          if(customerFound.promocion == "[]" || customerFound.promocion == "" || customerFound.promocion == "false"){
              ticketToCreate.extraInfoList.push({
                  key: 'promociones',
                  legend: 'promociones',
                  value: customerFound.promocion
              });
          }
          else{
              console.log(JSON.stringify(customerFound.promocion))
          // let tem = JSON.stringify(customerFound.promocion)
          // let json = tem.substr(13)
          // json = json.slice(0,-3);
          // console.log(json)
          // json = json.replace(/\\/g,"")
          let newDAta = JSON.parse(customerFound.promocion)
          console.log(newDAta)

          ticketToCreate.extraInfoList.push({
              key: 'promociones',
              legend: 'promociones',
              value: newDAta
          });
          }
      }

      if(customerFound.folio_trabajo){
          ticketToCreate.extraInfoList.push({
              key: 'folio_trabajo',
              legend: 'folio_trabajo',
              value: customerFound.folio_trabajo
          });
      }

      if(customerFound.tipo_trabajo){
          ticketToCreate.extraInfoList.push({
              key: 'tipo_trabajo',
              legend: 'tipo_trabajo',
              value: customerFound.tipo_trabajo
          });
      }
      
      // 
        // llamar a crear ticket

        this.isSpinning = true;
        this.ventasService.crear_ticket(ticketToCreate).subscribe(ticket => {
          console.log('res', ticket)
          this.createNotification('success', 'Ticket creado correctamente', '');
          if (!customerFound.suscriptor) {
            let datosTicket;
            datosTicket = [{
              idCalle: customerFound.calle,
              calle: customerFound.address,
              numExt: customerFound.number
            }];
            localStorage.setItem(`ticketInfoCalle${ticket.idTicket}`, JSON.stringify(datosTicket));
          }
          this.isSpinning = false;
          this.router.navigate([`tickets/details/${ticket.idTicket}`]);
          this.bsModalRef.hide();
        }, err => {
          this.isSpinning = false;
          console.log(err)
        })
      
    } else {
      this.createNotification('warning', 'Ingresa el nombre del cliente', '');
    }
  }

  private randomIdExternalCustomer(): number {
    const min: number = 10000000000;
    const max: number = 9223372036854775807;
    return Math.floor(Math.random() * (+max + 1 - +min)) + +min;
  }

  private getSelectedAddress(customerFound): string {
    const arrayAddressValues: any[] = [];

    arrayAddressValues.push({
      key: 'calle',
      legend: 'Calle',
      value: customerFound.calle
    });
    arrayAddressValues.push({
      key: 'numero_exterior',
      legend: 'Numero exterior',
      value: customerFound.numero
    });
    arrayAddressValues.push({
      key: 'numero_interior',
      legend: 'Numero interior',
      value: customerFound.interior
    });
    arrayAddressValues.push({
      key: 'departamento',
      legend: 'Departamento',
      value: customerFound.departamento
    });
    arrayAddressValues.push({
      key: 'bis',
      legend: 'bis',
      value: customerFound.bis
    });
    arrayAddressValues.push({
      key: 'colonia',
      legend: 'Colonia',
      value: customerFound.colonia
    });
    arrayAddressValues.push({
      key: 'codigo_postal',
      legend: 'Código postal',
      value: customerFound.cp
    });
    arrayAddressValues.push({
      key: 'entre_calle1',
      legend: 'Entre calle 1',
      value: customerFound.ecalle1
    });
    arrayAddressValues.push({
      key: 'entre_calle2',
      legend: 'Entre calle 2',
      value: customerFound.ecalle2
    });
    arrayAddressValues.push({
      key: 'latitud',
      legend: 'Latitud',
      value: customerFound.lat
    });
    arrayAddressValues.push({
      key: 'longitud',
      legend: 'Longitud',
      value: customerFound.lng
    });
    arrayAddressValues.push({
      key: 'telefono_casa',
      legend: 'Teléfono casa',
      value: customerFound.tel_casa
    });
    arrayAddressValues.push({
      key: 'telefono_oficina',
      legend: 'Teléfono oficina',
      value: customerFound.tel_ofi
    });
    arrayAddressValues.push({
      key: 'telefono_celular',
      legend: 'Teléfono celular',
      value: customerFound.tel_cel
    });
    arrayAddressValues.push({
      key: 'municipio',
      legend: 'Municipio',
      value: customerFound.municipio
    });
    arrayAddressValues.push({
      key: 'estado',
      legend: 'Estado',
      value: customerFound.estado
    });
    arrayAddressValues.push({
      key: 'departamento',
      legend: 'Departamento',
      value: customerFound.departamento
    });
    arrayAddressValues.push({
      key: 'sucursal',
      legend: 'Sucursal',
      value: typeof customerFound.sucursal === 'number' ?
        customerFound.sucursal.toString() :
        customerFound.sucursal
    });
    arrayAddressValues.push({
      key: 'id_calle',
      legend: 'id_calle',
      value: customerFound.id_calle ? customerFound.id_calle : ''
    });
    arrayAddressValues.push({
      key: 'id_calle1',
      legend: 'id_calle1',
      value: customerFound.id_calle1 ? customerFound.id_calle1 : ''
    });
    arrayAddressValues.push({
      key: 'id_calle2',
      legend: 'id_calle2',
      value: customerFound.id_calle2 ? customerFound.id_calle2 : ''
    });
    arrayAddressValues.push({
      key: 'id_colonia',
      legend: 'id_colonia',
      value: customerFound.id_colonia ? customerFound.id_colonia : ''
    });
    return JSON.stringify(arrayAddressValues);
  }

  verMapa(index: number, results: any) {
    this.indexActual = index;
    console.log(index)
    console.log(results)
    this.mostrarMapa = !this.mostrarMapa;
    // if(this.mostrarMapa == false && index == this.indexActual){
    //   this.indexActual = 999;
    // }
    console.log("Latitud del cliente", results.lat, " Longitud del cliente", results.lng);
    /* MAPA ESTATICO */
    setTimeout(() => {
      let coordenadas = results.lat + ',' + results.lng;
      let x: any = document.getElementById('mapa' + index);
      x.src = this.googleStaticMapAPI + `&markers=${coordenadas}&center=${coordenadas}`;
      console.log(this.googleStaticMapAPI + `&markers=${coordenadas}&center=${coordenadas}`)
      // this.srcMapa = this.googleStaticMapAPI + `&markers=${coordenadas}&center=${coordenadas}`
    }, 1000);
  }

  validate(event: any, type?: string, validacion?:any) {
    const key = event.data;
    
    if (type === 'money' && (/[-, ]/.test(key))) {
      event.preventDefault();
    } else if (type === 'card' && (/[-., ]/.test(key))) {
      event.preventDefault();
    } else if (type === 'tarjet' && !(/[\d]/.test(key)) && event.inputType != "deleteContentBackward") {
      event.preventDefault();
    } else if (type === 'int')  {
      if(!(/[\d]/.test(key)) && event.inputType != "deleteContentBackward"){
        event.preventDefault();
        console.log("diferente digito");
      }else{
        setTimeout(() => {
          console.log("digito", validacion);
          if(validacion == 'interior'){
            this.interior = this.interior.toString().trim();
            if (this.interior.length > 5) {
              this.interior = this.interior.slice(0, 5);
            }
            this.interior = this.interior !== '' ? parseInt(this.interior, 10) : null;
          }else if(validacion == 'departamento'){
            this.departamento = this.departamento.toString().trim();
            if (this.departamento.length > 5) {
              this.departamento = this.departamento.slice(0, 5);
            }
            this.departamento = this.departamento !== '' ? parseInt(this.departamento, 10) : null;
          }else if (validacion == 'lote'){
            this.lote = this.lote.toString().trim();
            if (this.lote.length > 5) {
              this.lote = this.lote.slice(0, 5);
            }
            this.lote = this.lote !== '' ? parseInt(this.lote, 10) : null;
          }
        }, 20);
      }
    }else if (type === 'char' && !(/[a-zA-Z0-9-., ]/.test(key)) && event.inputType !== "deleteContentBackward") {
      event.preventDefault();
    }
  }

  vaciarCalle() {
    this.streetList = [];
    this.id_calle = null;
    // Limpiar colonia también
    this.colonyList = [];
    this.id_colonia = null;
    this.textColony = '';
  }


IrAgenda(){
  this.bsModalAgent = this.bsModalService.show(AgendaVentasComponent, {
          
    backdrop: 'static',
    initialState: {
        ticket:this.ticket,
        
    }
});
}
filterGbisqueroup2(){
  console.log("aquigroup2",this.selectedGroupInputBusqueda);
}

toggleInfo() {

  var mostrarInfoAdicional = document.getElementById("mostrarInfoAdicional");
  console.log(mostrarInfoAdicional.style.display);
  if(mostrarInfoAdicional.style.display == ""){
    mostrarInfoAdicional.style.display = "none";  
  }
  mostrarInfoAdicional.style.display = mostrarInfoAdicional.style.display === "none" ? "block" : "none";
  console.log(mostrarInfoAdicional.style.display);
  this.mostrarFiltros = !this.mostrarFiltros;
}
onStreetSelected(selectedStreet: any) {
  // Realiza acciones para borrar ciertos campos
  // Puedes agregar lógica aquí para borrar campos específicos según tus necesidades
  console.log('Calle seleccionada:', selectedStreet);
 this.departamento = "";
 this.numeroCasa = "";
 this.lote = "";
 this.manzana = "";
 this.bis = "";
 this.interior = ""; // E.g., borrar campos:
  // this.otroCampo = null;
}

  setTextStreet(value: string) {
    this.textStreet = value;
  }

  // Método para enmascarar un nombre (o apellido)
  maskName(name: string): string {
    if (!name) return '';
    return this.sharedService.maskLastNames(name);
  }
  
}
